<!--
  --
  -- エラーの詳細を表示するコンポーネント
  --
  -->
<template>
  <article class="w-full max-w-xl pa-4 grey lighten-3 rounded">
    <h1 class="subtitle-2 text--secondary">Details:</h1>
    <p class="body-2 red--text text--darken-2 whitespace-pre-wrap break-all mb-0">{{errorText}}</p>
  </article>
</template>

<script>
export default {
  name: 'CDetails',
  props: {
    /**
     * エラーの詳細文字列
     */
    messages: {
      type: Array,
      required: true
    }
  },
  computed: {
    errorText () {
      return this.messages.join('\n')
    }
  }
}
</script>
